import { watchBusy } from "@frui.ts/screens/dist";
import type { interfaces } from "inversify";
import type Role from "entities/role";
import { computed } from "mobx";
import RoleRepository from "repositories/roleRepository";
import EventBus from "services/eventBus";
import LocalizationService from "services/localizationService";
import NotificationService from "services/notificationService";
import AppRouter from "services/router";
import { Modules } from "config";
import PermissionArea from "entities/permissionArea";
import OptionsService from "services/optionsService";
import SecurityService from "services/securityService";
import PermissionType from "entities/permissionType";
import EditableDetailViewModel from "../../../editableDetailViewModel";

export default class RoleUpdateViewModel extends EditableDetailViewModel<Role> {
  readonly modelName = "role";

  constructor(
    protected itemId: string,
    protected repository: RoleRepository,
    protected localizationService: LocalizationService,
    protected appRouter: AppRouter,
    protected notificationService: NotificationService,
    protected securityService: SecurityService,
    protected eventBus: EventBus,
    private optionsService: OptionsService
  ) {
    super(itemId);
  }

  @watchBusy
  protected async loadDetail() {
    return await this.repository.get(this.itemId);
  }

  @computed
  get permissionAreaOptions() {
    return this.optionsService.entityOptions(PermissionArea);
  }

  @computed
  get permissionTypeOptions() {
    return this.optionsService.internalEnumOptions(PermissionType);
  }

  updateData() {
    return this.repository.update(this.item);
  }

  translate(code: string, size?: number) {
    return this.localizationService.translateModule(Modules.users, `role.${code}`, size);
  }

  static Factory({ container }: interfaces.Context) {
    return (itemId: string) => {
      return new RoleUpdateViewModel(
        itemId,
        container.get(RoleRepository),
        container.get(LocalizationService),
        container.get(AppRouter),
        container.get(NotificationService),
        container.get(SecurityService),
        container.get(EventBus),
        container.get(OptionsService)
      );
    };
  }
}
